export default "__VITE_ASSET__cee115b5__"